import { render } from "./About.vue?vue&type=template&id=40bd3a9a"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script